/* GREY — Transparent header that becomes solid on scroll */
(function () {
  const headerSection = document.getElementById('shopify-section-header');
  if (!headerSection) return;

  // Respect the "Transparent header on page load" theme setting.
  // If it's off, keep the header solid at all times — skip the toggle entirely.
  if (window.greyHeaderTransparentEnabled === false) {
    headerSection.classList.remove('header--transparent');
    headerSection.classList.add('header--solid');
    return;
  }

  // Mark header as transparent at load
  headerSection.classList.add('header--transparent');

  let lastScroll = 0;
  const THRESHOLD = 80;

  function update() {
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY > THRESHOLD) {
      headerSection.classList.remove('header--transparent');
      headerSection.classList.add('header--solid');
    } else {
      headerSection.classList.add('header--transparent');
      headerSection.classList.remove('header--solid');
    }
    lastScroll = scrollY;
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();
